module.exports = __webpack_public_path__ + "static/media/my-tap-rewards-logo.1974b44b.svg";